import gsap from "gsap";
import React, { useEffect, useRef } from "react";
import ReturnButton from "../../utils/ReturnButton";
import "./popupPages.style.css";

const PopupPages = (props) => {
    const whatwedoRef = useRef();
    useEffect(() => {
        if (props.isSaturnClicked || props.isEarthClicked || props.isJupiterClicked || props.isUranusClicked) {
            gsap.to(whatwedoRef.current, { opacity: 1, delay: 1 });
        }
    }, [props]);

    return (
        <div className="popupPages" ref={whatwedoRef}>
            <h1>{props.content}</h1>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eligendi cum facilis natus dolores corporis
            voluptate nam dignissimos dolor, asperiores esse, sint distinctio blanditiis quasi fugit nesciunt est rem
            facere vero?
            <div className="popupPages-button-container">
                {props.onClickFunction === null ? null : (
                    <ReturnButton
                        onClickFunction={props.onClickFunction}
                        dispatch={props.dispatch}
                        content={"Our Works"}
                    />
                )}
                <ReturnButton content={"Back"} dispatch={props.dispatch} />
            </div>
        </div>
    );
};

export default PopupPages;
